angular.module('zc.projects')

.directive 'zcPageTypeSingle', ($filter, $q, PageType) ->
    # Should be used as attribute of <tr>, these don't work as elements
    restrict: 'A'
    scope:
      pageType: '='
      projectId: '='
      checkAllSampleMatchesPattern: '&'
      onDestroy: '&'
    templateUrl: "/templates/projects.settings/initialization/page_type_single.html"
    replace: true

    link: (scope, element, attrs) ->
      # select options
      scope.pageTypeOptions = []
      scope.matchTypes = []
      scope.devices = []
      $q.all [
        PageType.getPageTypeOptions scope.projectId
        PageType.getMatchTypes scope.projectId
        PageType.getDevices scope.projectId
      ]
      .then ([pageTypes, matchTypes, devices]) ->
        for pageType in pageTypes
          continue if pageType[1] is 'no_publish'
          scope.pageTypeOptions.push
            name: pageType[0]
            value: pageType[1]
        for matchType in matchTypes
          scope.matchTypes.push
            name: matchType[0]
            value: matchType[1]
        for device in devices
          scope.devices.push
            name: device[0]
            value: device[1]
      scope.isDestroying = false

      scope.remove = (pageType) ->
        if pageType.id # saved pageType
          scope.isDestroying = true
          PageType.destroy pageType
          .then (res) ->
            scope.onDestroy?()
            scope.isDestroying = false
        else # unsaved pageType
          scope.onDestroy?()
          scope.$apply()
          # TODO: move alertify into service?
          alertify.success($filter('translate')('projectsSettings.initialization.pageTypeSingle.deleted'))

      scope.update = (pageType) ->
        handler = (pageType) ->
          angular.extend(scope.pageType, pageType)
          scope.form.$setPristine()
        if pageType.id
          PageType.update({ projectId: pageType.project_id, id: pageType.id}, {page_type: pageType})
          .then handler
        else
          PageType.create({ projectId: pageType.project_id }, {page_type: pageType})
          .then handler

      scope.isCustomPageType = (page_type)->
        PageType.isCustomPageType page_type

      # always set dirty when creating new pageType
      unless scope.pageType.id
        scope.form.$setDirty()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/initialization/page_type_single.directive.coffee